import React from "react";

interface MoreHorizontalIconProps {
  size?: number;
  color?: string;
}

export default function MoreHorizontalIcon({ size = 16, color = "#666" }: MoreHorizontalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM13 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM3 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
        fill={color}
      />
    </svg>
  );
}